module.exports = __webpack_public_path__ + "static/media/Hello.e8827c82.svg";